/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.a-form-alert .cf-icon-svg {
  color: var(--gray);
  float: left;
}
.a-form-alert__text {
  display: block;
  margin-left: 1.25em;
}
.a-form-alert--success .cf-icon-svg {
  color: var(--green);
}
.a-form-alert--error .cf-icon-svg {
  color: var(--red);
}
.a-form-alert--warning .cf-icon-svg {
  color: var(--gold);
}